import { SvgIcon, SxProps } from "@mui/material";
import SvgMagnifyingGlassIcon from "jsx:../../../Images/Icons/FontAwesome/light/magnifying-glass.svg";

export function SearchIcon(props: SxProps) {
    return (
        <SvgIcon component={SvgMagnifyingGlassIcon} inheritViewBox sx={props} />
    );
}
